// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","526":"pages-DebugPage","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"b5924db6c2b21804cead","312":"9eadae93654f660b48b5","526":"bcab7fb5bf2f3ac05e40","777":"dbd5f4167ac41f5c6fa9"}[chunkId] + ".js";
};